module.exports = __webpack_public_path__ + "img/spielerfassung.72b8bc41.png";